import React from "react";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import initHistory from "boot/history";
import initStore from "boot/store";
import * as deps from "boot/deps";
import { windowResizeAction } from "store/actions";
import ReactDOM from "react-dom";
import Amplify from "aws-amplify";
import config from "config";

const history = initHistory();
const store = initStore({ ...deps }, history);

AppInit({ store });
AppRun({ store, history });

function AppInit({ store }) {
  store.dispatch(windowResizeAction());
  Amplify.configure({
    Auth: {
      mandatorySignIn: true,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
    },
  });
}

function AppRun({ store, history }) {
  const Application = (
    <React.StrictMode>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>
    </React.StrictMode>
  );

  ReactDOM.render(Application, document.getElementById("root"));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
